module.exports = __webpack_public_path__ + "assets/icons/recycle-active.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/jobcategories/recycle-active.png
// module id = ./src/styles/icons/jobcategories/recycle-active.png
// module chunks = 0